import * as React from 'react';
import { LocalForm, Control, Errors } from 'react-redux-form';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { renderNewTextField, renderCheckbox, renderMultilineTextField, renderErrorInfoText, renderSelectWithTextLabel } from '../../common/forms/FieldCreators';
import { localizations } from '../../localization/localization';
import { CompanyWithSettingsModel } from '../models/SettingsModels';
import FormItem from '../../components/forms/FormItem';
import nameof from '../../utils/nameof';
import { AddressModel, CompanyIndustryTypeOptions } from '../../common/models/CommonModels';
import * as validators from '../../common/validators/formValidators'
import MenuItem from '@material-ui/core/MenuItem';

interface DialogProps {
    open: boolean;
}

interface EditActions {
    onSubmit: (company: CompanyWithSettingsModel) => void;
    onCancel: () => void;
}

interface EditUserProps {
    model?: CompanyWithSettingsModel;
}

type EditCompanyFormProps = EditUserProps & EditActions & DialogProps;

const validateLength = (value: any) => {
    return validators.isLengthValid(value, 200);
}

const EditCompanyForm = (props: EditCompanyFormProps) => {
    return (
        <Dialog open={props.open}>
            <LocalForm onSubmit={(values) => props.onSubmit(values)} initialState={props.model}>
                <DialogTitle style={{ textAlign: "center" }}>
                    <Typography variant="h4" paragraph>{localizations.settings.editCompany}</Typography>
                </DialogTitle>
                <DialogContent>
                    <FormItem>
                        <Control.text model=".website" component={renderNewTextField} label={localizations.common.website} />
                    </FormItem>
                    <FormItem>
                        <Control.text
                            model={`.${nameof<CompanyWithSettingsModel>("address")}.${nameof<AddressModel>("streetAddress")}`}
                            component={renderNewTextField}
                            label={localizations.common.streetAddress}
                        />
                    </FormItem>
                    <FormItem>
                        <Control.text
                            model={`.${nameof<CompanyWithSettingsModel>("address")}.${nameof<AddressModel>("postalCode")}`}
                            component={renderNewTextField}
                            label={localizations.common.postCode}
                        />
                    </FormItem>
                    <FormItem>
                        <Control.text
                            model={`.${nameof<CompanyWithSettingsModel>("address")}.${nameof<AddressModel>("city")}`}
                            component={renderNewTextField}
                            label={localizations.common.postalCity}
                        />
                    </FormItem>
                    <FormItem>
                        <Control.text
                            label={localizations.company.companyIndustryType}
                            model=".industryType" 
                            component={renderSelectWithTextLabel} 
                            id="industryType-select"
                            >
                            {CompanyIndustryTypeOptions(localizations).map((opt: any) => <MenuItem key={opt.label} value={opt.value}>{opt.label}</MenuItem>)}
                        </Control.text>
                    </FormItem>
                    <FormItem>
                        <Control.text
                            model={".description"}
                            component={renderMultilineTextField} 
                            label={localizations.company.companyDescription}
                            controlProps={{rows: 5, placeholder: localizations.settings.companyDescription}}
                            validators={{isValidLength: validateLength}}
                        />
                        <Errors
                            model={".description"}
                            messages={{
                                isValidLength: localizations.validation.maxLength200
                            }}
                            show={{touched: true, focus: false }}
                            wrapper={renderErrorInfoText}
                        />
                    </FormItem>
                    <FormItem>
                        <FormControlLabel
                            control={<Control.checkbox model={`.${nameof<CompanyWithSettingsModel>("allowPartnerTracking")}`}
                            component={renderCheckbox} />}
                            label={localizations.settings.allowPartnerTracking}
                        />
                    </FormItem>
                </DialogContent>
                <DialogActions>
                    <Button onClick={props.onCancel}>{localizations.actions.cancel}</Button>
                    <Button type="submit">{localizations.actions.ok}</Button>
                </DialogActions>
            </LocalForm>
        </Dialog>
    );
}

export default EditCompanyForm;


// WEBPACK FOOTER //
// ./src/account/forms/EditCompanyForm.tsx